import { SupplierUpdatableInterface } from '../interfaces/supplier-updatable.interface';
import { PartialType, PickType } from '@nestjs/swagger';
import { SupplierDto } from './supplier.dto';

export class SupplierUpdateDto
  extends PartialType(
    PickType(SupplierDto, [
      'externalId',
      'name',
      'description',
      'email',
      'phone',
      'contactInfo',
      'archived',
    ]),
  )
  implements SupplierUpdatableInterface {}
